import React, { FC } from 'react';
import { Row, Tooltip, Typography } from 'components';
import { HighPriorityIcon, LowPriorityIcon, StandardPriorityIcon } from 'components/common/icons';
import styles from './styles.module.scss';

const { Text } = Typography;
export type BadgeType = 'HIGH' | 'STANDARD' | 'LOW';
export type PriorityType = 'HIGH' | 'STANDARD' | 'LOW';

type BadgeMapType = {
  label: string;
  color: string;
  icon: React.ReactNode;
};

const BADGE_MAPPING: Record<BadgeType, BadgeMapType> = {
  HIGH: {
    label: 'High Priority',
    color: '#FB3748',
    icon: <HighPriorityIcon />,
  },
  STANDARD: {
    label: 'Standard Priority',
    color: '#FF8447',
    icon: <StandardPriorityIcon />,
  },
  LOW: {
    label: 'Low Priority',
    color: '#0D6EFD',
    icon: <LowPriorityIcon />,
  },
};
const PRIORITY_MAPPING: Record<PriorityType, BadgeMapType> = {
  HIGH: {
    label: 'High',
    color: '#FB3748',
    icon: <HighPriorityIcon />,
  },
  STANDARD: {
    label: 'Standard',
    color: '#FF8447',
    icon: <StandardPriorityIcon />,
  },
  LOW: {
    label: 'Low',
    color: '#0D6EFD',
    icon: <LowPriorityIcon />,
  },
};

interface IPriorityBadge {
  tooltip?: string;
  type: BadgeType;
}
interface IPriority {
  tooltip?: string;
  type: PriorityType;
}

export const PriorityBadge: FC<IPriorityBadge> = React.memo((props) => {
  const { type: badgeType, tooltip } = props;
  const type = badgeType || 'STANDARD';
  return (
    <Tooltip
      styles={{ body: { color: '#525866', fontSize: 14, lineHeight: '20px' } }}
      placement={'bottom'}
      title={tooltip ?? ''}
      color={'#FBFBFB'}
    >
      <Row className={`${styles.badge} ${styles[type]}`} align={'middle'}>
        {BADGE_MAPPING[type].icon}
        <Text style={{ color: BADGE_MAPPING[type].color, fontSize: 12, fontWeight: 500 }}>
          {BADGE_MAPPING[type].label}
        </Text>
      </Row>
    </Tooltip>
  );
});
export const PriorityTag: FC<IPriority> = React.memo((props) => {
  const { type: priorityType, tooltip } = props;
  const type = priorityType || 'STANDARD';
  return (
    <Tooltip
      styles={{ body: { color: '#525866', fontSize: 14, lineHeight: '20px' } }}
      placement={'bottom'}
      title={tooltip ?? ''}
      color={'#FBFBFB'}
    >
      <Row className={`${styles.badge} ${styles[type]}`} align={'middle'}>
        {PRIORITY_MAPPING[type].icon}
        <Text style={{ color: PRIORITY_MAPPING[type].color, fontSize: 12, fontWeight: 500 }}>
          {PRIORITY_MAPPING[type].label}
        </Text>
      </Row>
    </Tooltip>
  );
});
